$bog_builderui_button $mol_button_minor
	minimal_height 32
	minimal_width 0
	variant \default
	attr *
		^
		bog_builderui_button_variant <= variant
